/**
 * Daynight Electrical — RFQ (Request a Quote)
 *
 * 1. Variant toggle  — MutationObserver watches the price element.
 *    When Dawn re-renders it (on variant change), we check for .price--rfq
 *    and show/hide the buy form vs RFQ trigger accordingly.
 * 2. Modal open/close
 * 3. AJAX form submit to Shopify contact endpoint
 * 4. Auto-open if URL contains ?rfq=1
 */
(function () {
  'use strict';

  var overlay   = document.getElementById('dn-rfq-overlay');
  var modal     = document.getElementById('dn-rfq-modal');
  var form      = document.getElementById('dn-rfq-form');
  var formWrap  = modal && modal.querySelector('.dn-rfq-modal__form-wrap');
  var successEl = modal && modal.querySelector('.dn-rfq-modal__success');

  /* ── helpers ────────────────────────────────────────────── */
  function setField(name, val) {
    var el = form && form.querySelector('[name="' + name + '"]');
    if (el) el.value = val || '';
  }

  function getVariantTitle(productInfoEl) {
    // Radio-based pickers (Dawn default)
    var radios = productInfoEl.querySelectorAll('input[name^="options"]:checked, input[name^="Option"]:checked');
    if (radios.length) {
      return Array.prototype.map.call(radios, function (r) { return r.value; }).join(' / ');
    }
    // Select-based pickers
    var selects = productInfoEl.querySelectorAll('select[id^="Option-"]');
    if (selects.length) {
      return Array.prototype.map.call(selects, function (s) {
        return s.options[s.selectedIndex] ? s.options[s.selectedIndex].text : '';
      }).filter(Boolean).join(' / ');
    }
    return '';
  }

  /* ── toggle buy vs RFQ ──────────────────────────────────── */
  function toggleBuyState(productInfoEl, isRFQ) {
    var normal  = productInfoEl.querySelector('.dn-rfq-normal');
    var trigger = productInfoEl.querySelector('.dn-rfq-trigger-wrapper');
    if (normal)  normal.classList.toggle('dn-rfq-hidden', isRFQ);
    if (trigger) trigger.classList.toggle('dn-rfq-hidden', !isRFQ);
  }

  /* ── open modal ─────────────────────────────────────────── */
  function openModal(btn) {
    if (!modal || !overlay) return;

    var productInfoEl = (btn && btn.closest('product-info')) || document;

    var titleEl = productInfoEl.querySelector && productInfoEl.querySelector('h1');
    var productTitle = (titleEl && titleEl.textContent.trim()) || (btn && btn.dataset.rfqProduct) || '';

    var variantTitle = getVariantTitle(productInfoEl) || (btn && btn.dataset.rfqVariant) || '';

    var skuEl = productInfoEl.querySelector && productInfoEl.querySelector('[id^="Sku-"], [id^="dne-sku-"]');
    var sku = '';
    if (skuEl) {
      // Strip "SKU: " prefix if present
      sku = skuEl.textContent.replace(/^SKU:\s*/i, '').trim();
    }
    if (!sku && btn) sku = btn.dataset.rfqSku || '';

    // Update summary display
    var nameEl    = modal.querySelector('.dn-rfq-modal__product-name');
    var variantEl = modal.querySelector('.dn-rfq-modal__product-variant');
    var skuDispEl = modal.querySelector('.dn-rfq-modal__product-sku');
    if (nameEl)    nameEl.textContent    = productTitle;
    if (variantEl) variantEl.textContent = variantTitle;
    if (skuDispEl) skuDispEl.textContent = sku ? 'SKU: ' + sku : '';

    // Populate hidden fields
    setField('contact[product_title]', productTitle);
    setField('contact[variant_title]', variantTitle);
    setField('contact[sku]',           sku);
    setField('contact[product_url]',   window.location.href);

    // Reset success state
    if (successEl && !successEl.hasAttribute('hidden')) {
      successEl.setAttribute('hidden', '');
      if (formWrap) formWrap.removeAttribute('hidden');
    }

    overlay.removeAttribute('hidden');
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('dn-rfq-modal--open');
        overlay.classList.add('dn-rfq-overlay--open');
      });
    });

    // Focus first visible input
    setTimeout(function () {
      var first = form && form.querySelector('input:not([type="hidden"])');
      if (first) first.focus();
    }, 320);
  }

  /* ── close modal ─────────────────────────────────────────── */
  function closeModal() {
    if (!modal || !overlay) return;
    modal.classList.remove('dn-rfq-modal--open');
    overlay.classList.remove('dn-rfq-overlay--open');
    document.body.style.overflow = '';
    setTimeout(function () {
      modal.setAttribute('hidden', '');
      overlay.setAttribute('hidden', '');
    }, 300);
  }

  /* ── AJAX submit ─────────────────────────────────────────── */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var productTitle = (form.querySelector('[name="contact[product_title]"]') || {}).value || '';
      var variantTitle = (form.querySelector('[name="contact[variant_title]"]') || {}).value || '';
      var sku          = (form.querySelector('[name="contact[sku]"]') || {}).value || '';
      var productUrl   = (form.querySelector('[name="contact[product_url]"]') || {}).value || window.location.href;
      var qty          = (form.querySelector('[name="contact[quantity]"]') || {}).value || '1';
      var notes        = (form.querySelector('[name="contact[notes]"]') || {}).value || '';

      var lines = [
        'Quote Request \u2014 ' + productTitle,
        variantTitle ? 'Variant: ' + variantTitle : null,
        sku          ? 'SKU: '     + sku          : null,
        'Product URL: ' + productUrl,
        'Quantity: '    + qty,
        notes ? 'Notes: ' + notes : null
      ].filter(Boolean);

      setField('contact[body]', lines.join('\n'));

      var submitBtn   = form.querySelector('[type="submit"]');
      var origText    = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending\u2026'; }

      fetch(form.action || '/contact', { method: 'POST', body: new FormData(form), redirect: 'follow' })
        .then(function (r) {
          var ok = r.url && r.url.indexOf('posted_successfully') !== -1;
          if (ok || r.ok) {
            if (formWrap) formWrap.setAttribute('hidden', '');
            if (successEl) successEl.removeAttribute('hidden');
          } else {
            throw new Error(r.status);
          }
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
          alert('Something went wrong. Please try again or contact us directly.');
        });
    });
  }

  /* ── click delegation ───────────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-rfq-open]')) {
      e.preventDefault();
      openModal(e.target.closest('[data-rfq-open]'));
      return;
    }
    if (e.target.closest('[data-rfq-close]')) { closeModal(); return; }
    if (overlay && e.target === overlay)       { closeModal(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) closeModal();
  });

  /* ── variant toggle via MutationObserver ─────────────────── */
  // Dawn re-renders the #price-{sectionId} element via AJAX on variant change.
  // We watch it: if the new HTML contains .price--rfq → RFQ mode, else buy mode.
  document.querySelectorAll('product-info').forEach(function (el) {
    var priceEl = el.querySelector('[id^="price-"]');
    if (!priceEl) return;
    new MutationObserver(function () {
      var isRFQ = !!priceEl.querySelector('.price--rfq');
      toggleBuyState(el, isRFQ);
      // Keep trigger button data attrs fresh
      var btn = el.querySelector('[data-rfq-open]');
      if (btn) {
        btn.dataset.rfqVariant = getVariantTitle(el);
        var skuEl = el.querySelector('[id^="Sku-"], [id^="dne-sku-"]');
        btn.dataset.rfqSku = skuEl ? skuEl.textContent.replace(/^SKU:\s*/i, '').trim() : '';
      }
    }).observe(priceEl, { childList: true, subtree: true, attributes: true });
  });

  /* ── auto-open on ?rfq=1 ────────────────────────────────── */
  if (window.location.search.indexOf('rfq=1') !== -1) {
    var btn = document.querySelector('[data-rfq-open]');
    if (btn) setTimeout(function () { openModal(btn); }, 600);
  }
}());
